import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  Cnpj,
  CustomCalendar,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  CustomPanel,
  CustomTabView,
  DateTime,
  InputCnpj,
  InputNumeroInteiro,
  InputPhone,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'

import { showMessageBox } from '../../../../store/actions/system.actions'
import * as EmissoresHttp from '../../../../services/api/https/settings/emissor-cte.http'
import * as SystemHttp from '../../../../services/api/https/system/system.http'

import { errorHandler } from '../../../../services/util/error.service'
import { TabPanel } from 'primereact/tabview'
import { Fieldset } from 'primereact/fieldset'
import { tableCellCentered } from '../../../../assets/js/styles'

import ModalUltimoEmitido from './ModalUltimoEmitido'

function EmissorCte({ dispatch, history }) {
  // Vars
  const initEmissor = {
    id: null,
    rntrc: '',
    cnpj: '',
    razao_social: '',
    inscricao_estadual: '',
    uf: '',
    indicador_icms: '',
    telefone: '(__)_____-____',
    activated: true,
    token_homolog: '',
    token_prod: '',
    cte_num_serie: null,
    cte_ultimo_emitido: null,
    address: '',
    number: '',
    district: '',
    city_id: null,
    cep: '',
    selectedCity: null,
  }

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [emissores, setEmissores] = useState([])
  const [state, setState] = useState(initEmissor)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    getEmissores()
  }, [])

  // Events
  const onBtnNovo = () => {
    setState(initEmissor)
    setShowModal(true)
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const onModalSave = async emissor => {
    const index = emissores.findIndex(l => l.id === emissor.id)
    if (index !== -1) {
      const nEmissores = [...emissores]
      nEmissores[index] = emissor
      setEmissores(nEmissores)
    } else {
      setEmissores([...emissores, emissor])
    }
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onEmissorUpdated = emissor => {
    setEmissores(prev => prev.map(e => (e.id === emissor.id ? emissor : e)))
  }

  const onRowClicked = emissor => {
    setState({
      id: emissor.id,
      rntrc: emissor.rntrc,
      cnpj: emissor.cnpj,
      razao_social: emissor.razao_social,
      inscricao_estadual: emissor.inscricao_estadual,
      uf: emissor.uf,
      indicador_icms: emissor.indicador_icms,
      telefone: emissor.telefone,
      activated: emissor.activated,
      token_homolog: emissor.token_homolog || '',
      token_prod: emissor.token_prod || '',
      validade_certificado: new Date(emissor.validade_certificado.split('T')[0] + 'T04:00:00'),
      cte_num_serie: emissor.cte_num_serie,
      cte_ultimo_emitido: emissor.cte_ultimo_emitido,
      address: emissor.address || '',
      number: emissor.number || '',
      district: emissor.district || '',
      city_id: emissor.city_id || null,
      cep: emissor.cep || '',
      selectedCity: emissor.city_id ? { id: emissor.city_id, name: emissor.city_name } : null,
    })
    setShowModal(true)
  }

  // Helpers
  const getEmissores = async () => {
    try {
      setIsLoading(true)
      const fetchedEmissores = await EmissoresHttp.getEmissores()

      setEmissores(fetchedEmissores)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>S.23 - Gestão de Emissores de CTe</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <EmissorDataTable emissores={emissores} onRowClick={onRowClicked} />
          )}
        </CustomPanel>
      </div>
      <EmissorModal
        isVisible={showModal}
        onError={onModalError}
        onSuccess={onModalSave}
        onEmissorUpdated={onEmissorUpdated}
        onClose={onModalClose}
        emissor={state}
      />
    </div>
  )
}

const IndicadorIcmsOptions = [
  {
    id: 1,
    name: 'Contribuinte ICMS',
  },
  {
    id: 2,
    name: 'Contribuinte isento de inscrição',
  },
  {
    id: 9,
    name: 'Não Contribuinte',
  },
]

function EmissorModal({ emissor, isVisible, onClose, onSuccess, onEmissorUpdated, onError }) {
  const [activeIndex, setActiveIndex] = useState(0)

  // Render
  return (
    <CustomModal
      width={800}
      header="Emissor"
      isVisible={isVisible}
      contentStyle={{ overflowY: 'auto', maxHeight: '80vh' }}
      onClose={() => {
        setActiveIndex(0)
        onClose()
      }}
    >
      <CustomTabView activeIndex={activeIndex} onTabChange={value => setActiveIndex(value)}>
        <TabPanel header="Dados">
          <DadosTab
            emissor={emissor}
            onSuccess={onSuccess}
            onEmissorUpdated={onEmissorUpdated}
            onError={onError}
          />
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

function DadosTab({ emissor, onSuccess, onEmissorUpdated, onError }) {
  // Hooks
  const [state, setState] = useState({
    ufs: [],
    cities: [],
    selectedUf: null,
    selectedCity: null,
    selectedIndicadorICMS: null,
    ...emissor,
  })
  const [showUltEmitidoModal, setShowUltEmitidoModal] = useState(false)

  useEffect(() => {
    const loadUf = async () => {
      await fetchUFs(emissor.uf)
      // Carregar cidades se já tem UF e city_id
      if (emissor.uf && emissor.city_id) {
        const ufs = await SystemHttp.getUfs()
        const ufEncontrada = ufs.find(uf => uf.uf === emissor.uf)
        if (ufEncontrada && ufEncontrada.id) {
          const cities = await SystemHttp.getCities(ufEncontrada.id)
          const cidadeEncontrada = cities.find(city => city.id === emissor.city_id)
          setState(prevState => ({
            ...prevState,
            cities: cities,
            selectedCity: cidadeEncontrada || null,
          }))
        }
      }
    }
    setState({
      ufs: [],
      cities: [],
      selectedUf: null,
      selectedCity: null,
      selectedIndicadorICMS: IndicadorIcmsOptions.find(
        indicador => indicador.id === emissor.indicador_icms,
      ),
      token_homolog: emissor.token_homolog || '',
      token_prod: emissor.token_prod || '',
      ...emissor,
    })
    loadUf()
  }, [emissor])

  // Carregar cidades quando selectedUf mudar
  useEffect(() => {
    if (state.selectedUf) {
      fetchCities(state.selectedUf.id)
    }
  }, [state.selectedUf])

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const {
        id,
        rntrc,
        cnpj,
        razao_social,
        inscricao_estadual,
        uf,
        indicador_icms,
        telefone,
        activated,
        validade_certificado,
        token_homolog,
        token_prod,
        cte_num_serie,
        cte_ultimo_emitido,
        address,
        number,
        district,
        city_id,
        cep,
      } = state

      if (!cnpj || cnpj.length !== 14) throw new Error('CNPJ Incorreto')
      if (!razao_social) throw new Error('Razão Social Incorreto')
      const telefoneNumbers = telefone.replace(/\D/g, '')
      if (!telefoneNumbers) throw new Error('Telefone Inválido')
      if (rntrc.trim().length !== 8) throw new Error('RNTRC Incorreto')
      if (!inscricao_estadual) throw new Error('Inscrição Estadual Incorreto')
      if (!uf) throw new Error('Estado Inválido')
      if (!indicador_icms) throw new Error('Indicador ICMS Inválido')
      if (!validade_certificado) throw new Error('Data de Expiração do Certificado Inválida')
      if (!cte_num_serie) throw new Error('Cte Número de Série e Obrigatório')
      if (!id && !cte_ultimo_emitido) throw new Error('Cte: Número do Último Emitido')
      if (!token_homolog) throw new Error('Token Homologação é obrigatório')
      if (!token_prod) throw new Error('Token Produção é obrigatório')

      const emissor = await EmissoresHttp.saveEmissor({
        id,
        rntrc,
        cnpj,
        razao_social,
        inscricao_estadual,
        uf,
        indicador_icms,
        telefone: telefoneNumbers,
        activated,
        validade_certificado,
        token_homolog,
        token_prod,
        cte_num_serie,
        cte_ultimo_emitido: id ? undefined : cte_ultimo_emitido,
        address,
        number,
        district,
        city_id,
        cep,
      })

      onSuccess(emissor)
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  const fetchUFs = async (uf_selected = null) => {
    await SystemHttp.getUfs()
      .then(ufs => {
        if (uf_selected)
          setState(prevState => ({
            ...prevState,
            ufs: ufs,
            selectedUf: ufs.find(uf => uf.uf === uf_selected),
          }))
        else setState(prevState => ({ ...prevState, ufs: ufs }))
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }

  const fetchCities = async uf_id => {
    await SystemHttp.getCities(uf_id)
      .then(cities => {
        if (state.city_id) {
          setState(prevState => ({
            ...prevState,
            cities: cities,
            selectedCity: cities.find(city => city.id === Number(state.city_id)),
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            cities: cities,
          }))
        }
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }
  const onCnpjChange = cnpj => {
    setState({
      ...state,
      cnpj,
    })
    if (cnpj.length === 14) fetchCnpjData(cnpj)
  }
  const fetchCnpjData = async cnpj => {
    if (!cnpj || cnpj.length !== 14) return

    try {
      const data = await SystemHttp.getCnpjDataFocusNfe(cnpj)

      // Atualizar os campos do emissor
      setState(prevState => ({
        ...prevState,
        razao_social: data.razao_social,
        address: data.endereco.logradouro,
        number: data.endereco.numero,
        district: data.endereco.bairro,
        cep: data.endereco.cep,
        uf: data.endereco.uf,
        city_id: data.endereco.codigo_ibge, // Usar codigo_ibge como no cadastro de empresa
      }))

      // Buscar e definir UFs
      const ufs = await SystemHttp.getUfs()
      const ufEncontrada = ufs.find(uf => uf.uf === data.endereco.uf)

      if (ufEncontrada) {
        setState(prevState => ({
          ...prevState,
          ufs: ufs,
          selectedUf: ufEncontrada,
        }))
      }
    } catch (error) {
      onError('Não foi possível buscar os dados do CNPJ automaticamente')
    }
  }

  const onUltEmitidoSalvo = emissorAtualizado => {
    setState(prevState => ({
      ...prevState,
      cte_ultimo_emitido: emissorAtualizado.cte_ultimo_emitido,
    }))
    setShowUltEmitidoModal(false)
    onEmissorUpdated(emissorAtualizado)
  }

  // Render
  return (
    <>
      <form className="p-grid">
        <div className="p-md-4 p-col-12">
          <InputCnpj
            label="CNPJ :*"
            marginTop={10}
            value={state.cnpj}
            onChange={({ value }) => onCnpjChange(value)}
          />
        </div>
        <div className="p-md-8 p-col-12">
          <InputText
            label="Razão Social :*"
            marginTop={10}
            value={state.razao_social}
            onChange={value => setState({ ...state, razao_social: value })}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputPhone
            label="Telefone :*"
            marginTop={10}
            value={state.telefone}
            onChange={value => setState({ ...state, telefone: value })}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputNumeroInteiro
            label="RNTRC :*"
            marginTop={10}
            value={state.rntrc}
            onChange={value => setState({ ...state, rntrc: value })}
            format={'########'}
            id="rntrc"
          />
          <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
            Registro Nacional de Transportadores Rodoviários de Cargas{' '}
          </p>
        </div>
        <div className="p-md-4 p-col-12">
          <InputNumeroInteiro
            label="Inscrição Estadual :*"
            marginTop={10}
            value={state.inscricao_estadual}
            onChange={value => setState({ ...state, inscricao_estadual: value })}
            format={'##############'}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <CustomDropdown
            optionLabel="name"
            options={state.ufs}
            value={state.selectedUf}
            label="Estado :*"
            filter={true}
            onChange={value => {
              setState(prevState => {
                prevState.selectedUf = value
                prevState.uf = value.uf
                prevState.cities = [] // Limpar cidades ao mudar estado
                prevState.selectedCity = null
                prevState.city_id = null
                return { ...prevState }
              })
              if (value && value.id) {
                fetchCities(value.id)
              }
            }}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <CustomDropdown
            optionLabel="name"
            options={IndicadorIcmsOptions}
            value={state.selectedIndicadorICMS}
            label="Indicador ICMS :*"
            onChange={value => {
              setState(prevState => {
                prevState.selectedIndicadorICMS = value
                prevState.indicador_icms = value.id
                return { ...prevState }
              })
            }}
          />
        </div>
        <div className="p-col-4" style={{ display: 'flex', alignItems: 'end' }}>
          <CustomCalendar
            label="Data Expiração Certificado:"
            value={state.validade_certificado}
            onChange={value => {
              setState({ ...state, validade_certificado: value })
            }}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label="Cte Núm. Série :*"
            marginTop={10}
            value={state.cte_num_serie}
            onChange={value => setState({ ...state, cte_num_serie: value })}
          />
        </div>
        <div className="p-col-6">
          {state.id ? (
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 5 }}>
              <div style={{ flex: 1 }}>
                <InputNumeroInteiro
                  label="Cte Últ. Emitido:"
                  marginTop={10}
                  value={state.cte_ultimo_emitido}
                  disabled
                />
              </div>
              <Btn
                onClick={() => setShowUltEmitidoModal(true)}
                style={{ minWidth: 'auto', height: 30, padding: '0 10px' }}
              >
                <i className="pi pi-pencil" />
              </Btn>
            </div>
          ) : (
            <InputNumeroInteiro
              label="Cte Últ. Emitido:*"
              marginTop={10}
              value={state.cte_ultimo_emitido}
              onChange={value => setState({ ...state, cte_ultimo_emitido: value })}
            />
          )}
        </div>
        <div className="p-col-4" style={{ display: 'flex', alignItems: 'end' }}>
          <CustomCheckbox
            onChange={value => setState({ ...state, activated: value })}
            checked={state.activated}
          >
            Ativo
          </CustomCheckbox>
        </div>

        <div className="p-col-12" style={{ marginTop: 10 }}>
          <Fieldset legend="Autenticação" toggleable={false}>
            <div className="p-grid">
              <div className="p-md-6 p-col-12">
                <InputText
                  label="Token Homologação :*"
                  marginTop={10}
                  value={state.token_homolog}
                  onChange={value => setState({ ...state, token_homolog: value })}
                />
              </div>
              <div className="p-md-6 p-col-12">
                <InputText
                  label="Token Produção :*"
                  marginTop={10}
                  value={state.token_prod}
                  onChange={value => setState({ ...state, token_prod: value })}
                />
              </div>
            </div>
          </Fieldset>
        </div>

        {/* Nova seção de Endereço */}
        <div className="p-col-12" style={{ marginTop: 20, marginBottom: 10 }}>
          <h4>Dados de Endereço (para CTe Globalizado)</h4>
        </div>

        <div className="p-md-8 p-col-12">
          <InputText
            label="Endereço :"
            marginTop={10}
            value={state.address}
            onChange={value => setState({ ...state, address: value })}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputText
            label="Número :"
            marginTop={10}
            value={state.number}
            onChange={value => setState({ ...state, number: value })}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <InputText
            label="Bairro :"
            marginTop={10}
            value={state.district}
            onChange={value => setState({ ...state, district: value })}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <InputText
            label="CEP :"
            marginTop={10}
            value={state.cep}
            onChange={value => setState({ ...state, cep: value })}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <CustomDropdown
            optionLabel="name"
            options={state.cities}
            value={state.selectedCity}
            label="Cidade :"
            filter={true}
            onChange={value => {
              setState(prevState => {
                prevState.selectedCity = value
                prevState.city_id = value ? value.id : null
                return { ...prevState }
              })
            }}
          />
        </div>

        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
      <ModalUltimoEmitido
        isVisible={showUltEmitidoModal}
        emissor={state}
        onClose={() => setShowUltEmitidoModal(false)}
        onSuccess={onUltEmitidoSalvo}
        onError={onError}
      />
    </>
  )
}

function EmissorDataTable({ emissores, onRowClick }) {
  const [globalFilter, setGlobalFilter] = useState('')

  return (
    <DataTable
      value={emissores}
      selectionMode="single"
      onSelectionChange={e => onRowClick(e.value)}
      paginator
      rows={10}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="razao_social" header="Emissor" />
      <Column
        field="cnpj"
        header="CNPJ"
        style={{ textAlign: 'center', width: 200 }}
        body={rowData => <Cnpj>{rowData.cnpj}</Cnpj>}
      />
      <Column field="rntrc" header="RNTRC" style={tableCellCentered(200)} />
      <Column
        field="inscricao_estadual"
        header="Inscrição Estadual"
        style={tableCellCentered(200)}
      />
      <Column
        field="validade_certificado"
        header="Validade Certificado"
        style={tableCellCentered(200)}
        body={item => <DateTime>{item.validade_certificado}</DateTime>}
      />
      <Column
        field="activated"
        header="Ativo"
        style={{ textAlign: 'center', width: 100 }}
        body={rowData => <CustomCheckbox disabled checked={rowData.activated} />}
      />
    </DataTable>
  )
}

export default connect()(withRouter(EmissorCte))
